import React, { FC } from 'react';
import { Col, Container, Row } from 'react-bootstrap';

import { COMPANY_NAME, SLOGAN } from '../../constants/captions';
import FooterList from '../FooterList';
import Logo from '../Logo';
import * as styles from './Footer.module.scss';

const ABOUT_TITLE = COMPANY_NAME;
const ABOUT_SECTION = [
  { label: 'About', path: '/about' },
  { label: 'Projects', path: '/projects' },
  { label: 'Contact', path: '/contact' },
];

const LEGAL_TITLE = 'Legal';
const LEGAL_SECTION = [
  { label: 'Privacy Policy', path: '/privacy-policy' },
  { label: 'Terms of Use', path: '/terms-of-use' },
];

const COPYRIGHT = `© ${new Date().getFullYear()} ${COMPANY_NAME}. All Rights Reserved.`;

const Footer: FC = () => {
  return (
    <footer className={styles.footer}>
      <Container>
        <Row>
          <Col sm={12} md={4} lg={8}>
            <Logo/>
            <p className={styles.brandDescription}>{SLOGAN}</p>
          </Col>
          <Col sm={6} md={4} lg={2}>
            <FooterList title={LEGAL_TITLE} items={LEGAL_SECTION} />
          </Col>
          <Col sm={6} md={4} lg={2}>
            <FooterList title={ABOUT_TITLE} items={ABOUT_SECTION} />
          </Col>
        </Row>
        <Row>
          <div className={styles.copyright}>{COPYRIGHT}</div>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;